import { alpha, styled } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { DRAWER_SIZE } from '../../const';

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

export const CustomAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background:
    theme.palette.mode === 'dark'
      ? `linear-gradient(180deg, ${alpha('#081320', 0.94)} 0%, ${alpha('#0d1b2d', 0.88)} 100%)`
      : `linear-gradient(180deg, ${alpha('#ffffff', 0.92)} 0%, ${alpha('#eef5ff', 0.9)} 100%)`,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.08 : 0.6)}`,
  boxShadow:
    theme.palette.mode === 'dark'
      ? `0 14px 34px ${alpha('#01050d', 0.42)}`
      : `0 12px 30px ${alpha('#9bb0c9', 0.16)}`,
  backdropFilter: 'blur(18px)',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: DRAWER_SIZE,
    width: `calc(100% - ${DRAWER_SIZE}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
